<template>
  <master-page>
    
        <v-card class="mt-4">

          <v-card-title class="pa-0 sticky">
            <v-toolbar color="primary">

              <v-toolbar-title>
                <v-icon large left color="white">mdi-cog</v-icon>
                <span class="title font-weight-light" style="color: white">Cadastro Parâmetros do Sistema</span>
              </v-toolbar-title>

              <v-spacer/>

              <v-toolbar-items>
                <v-btn color="white" class="pr-2" text @click="Salvar()" :disabled="!valid">Salvar</v-btn>
              </v-toolbar-items>

              <template v-slot:extension>
                <v-tabs v-model="tabActive" color="secondary">
                  <v-tab>Geral</v-tab>
                  <v-tab>Cobrança</v-tab>
                  <v-tab>NFS-e</v-tab>
                  <v-tab>Beneficiário</v-tab>
                  <v-tab>Doador</v-tab>
                  <v-tab>Pessoal</v-tab>
                  <v-tab>Informativo</v-tab>
                </v-tabs>
              </template>
            
            </v-toolbar>
          </v-card-title>

          <v-card-text class="my-3">

            <v-tabs-items v-model="tabActive">

              <v-tab-item>
                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-switch v-model="parametro.doadorGrupoObrigatorio" label="Doador Grupo Obrigatório" dense/>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-switch v-model="parametro.validarContaContabilMovimentacao"
                      label="Validar conta contábil nas movimentações financeiras"
                      hint="Quando ativado, bancos e itens gerenciais devem possuir uma conta contábil Analítica."
                      persistent-hint dense/>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Envio dos boletos</legend>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="parametro.smtp" label="SMTP" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="parametro.porta" label="Porta" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="parametro.usuario" label="Usuário" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="parametro.senha" label="Senha" :counter="25" maxlength="25" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="2" sm="2">
                      <v-switch v-model="parametro.usarSSL" label="Usar SSL" style="margin-top: 5px" dense/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="parametro.email" label="E-mail" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="parametro.assunto" label="Assunto" :counter="45" maxlength="45" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
                <fieldset class="pa-4">
                  <legend>Instruções do Boleto</legend>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="parametro.juros" label="Juros(%)" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <v-text-field v-model="parametro.multa" label="Multa(%)" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="parametro.instrucao1" label="Instrução 1" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="parametro.instrucao2" label="Instrução 2" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                      <v-text-field v-model="parametro.instrucao3" label="Instrução 3" :counter="100" maxlength="100" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Informações para gerar nota de serviço eletrônica</legend>
                  <v-row>
                    <v-col cols="12">
                      <v-switch style="margin-top: 5px" v-model="parametro.producaoNFse" :label="`Ambiente: ${parametro.producaoNFse ? 'Produção' : 'Homologação'}`" dense outlined/>
                    </v-col>
                    <!-- <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.certificado" label="Certificado (Serial)" :counter="35" maxlength="35" dense outlined/>
                    </v-col> -->
                    <!-- <v-col cols="12" sm="6" md="4" lg="3">
                      <v-text-field type="password" v-model="parametro.certificadoSenha" label="Senha" dense outlined/>
                    </v-col> -->
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.codigoServico" label="Código Serviço (Nacional)" :counter="10" maxlength="10" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.codigoTributacaoMunicipio" label="Código Tributação (Municipal)" :counter="10" maxlength="10" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.codigoNbs" label="Código NBS" :counter="9" maxlength="9" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="parametro.textoNFSe" label="Texto padrão" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
                <fieldset class="pa-4">
                  <legend>Envio de certificado digital</legend>
                  <v-row dense>
                    <v-col cols="12" sm="10">
                      <v-row>
                        <v-col cols="12" sm="12" md="5" v-if="!!!parametro.certificadoNome">
                          <v-file-input v-model="certificadoArquivo" label="Arquivo certificado" dense outlined show-size accept=".pfx,.p12" :disabled="enviandoCertificado"/>
                        </v-col>
                        <v-col cols="12" sm="12" md="5" v-else>
                          <v-chip close @click:close="LimparCertificadoNome">{{ parametro.certificadoNome }}</v-chip>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field type="datetime-local" v-model="parametro.certificadoValidade" label="Validade certificado" dense outlined readonly/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field type="password" v-model="parametro.certificadoSenha" label="Senha certificado" dense outlined :disabled="enviandoCertificado"/>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" style="display: flex; align-items: flex-start; justify-content: center;">
                      <v-btn color="primary" :loading="enviandoCertificado" :disabled="!certificadoArquivo || !parametro.certificadoSenha || enviandoCertificado" @click="EnviarCertificadoDigital()">
                        Enviar
                      </v-btn>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Nome para os campos personalizados</legend>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo01" label="Campo 1" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo02" label="Campo 2" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo03" label="Campo 3" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo04" label="Campo 4" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo05" label="Campo 5" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo06" label="Campo 6" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo07" label="Campo 7" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo08" label="Campo 8" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo09" label="Campo 9" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo10" label="Campo 10" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo11" label="Campo 11" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo12" label="Campo 12" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo13" label="Campo 13" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo14" label="Campo 14" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="parametro.beneficiarioCampo15" label="Campo 15" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Nome para os campos personalizados</legend>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.doadorCampo01" label="Campo 1" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.doadorCampo02" label="Campo 2" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.doadorCampo03" label="Campo 3" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.doadorCampo04" label="Campo 4" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.doadorCampo05" label="Campo 5" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item>
                <fieldset class="pa-4">
                  <legend>Pessoal</legend>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.pessoalCampo01" label="Campo 1" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.pessoalCampo02" label="Campo 2" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="parametro.pessoalCampo03" label="Campo 3" :counter="50" maxlength="50" dense outlined/>
                    </v-col>
                  </v-row>
                </fieldset>
              </v-tab-item>

              <v-tab-item v-if="sessionApp.plano == 'O'">
                <v-row dense>                  
                  <v-col cols="12" sm="12">
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-textarea v-model="informativo.emails" label="Email(s)" single-line dense outlined/>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <span v-for="(email, index) in informativo.emails.split(',')" :key="index">
                          <v-chip class="ma-1" v-if="email.length > 0">
                            <span> {{ email }} </span>
                          </v-chip>
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field type="number" v-model.number="informativo.periodicidade" label="Periodicidade (dias) para envio automático" dense outlined/>
                  </v-col>
                  <v-col cols="12" sm="1"></v-col>
                  <v-col cols="12" sm="4">
                    <v-btn color="primary" @click="EnviarAgora()">Enviar Agora</v-btn>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="6" md="4">
                    <v-switch label="Saldos nas contas correntes" v-model="informativo.contaCorrente" dense/>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-switch label="Compromissos vencidos e não pagos" v-model="informativo.compromissos" dense/>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-switch label="Recebíveis vencidos e não quitados" v-model="informativo.recebiveis" dense/>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-switch label="Projetos com rubricas negativas (acima de 10%)" v-model="informativo.subAtividadeNegativa" dense/>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-switch label="Pipeline (CRM)" v-model="informativo.crm" dense/>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-switch label="Beneficiários (Retenção)" v-model="informativo.beneficiarios" dense/>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-else>
                <v-row dense>
                  <v-col cols="12">
                    <span>Restrito ao seu usuário ou plano.</span>
                  </v-col>
                </v-row>
              </v-tab-item>

            </v-tabs-items>

          </v-card-text>

        </v-card>

    <v-overlay :value="primeiraCarga">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </master-page>
</template>

<script>
import { Informativo } from '../../../core/domain/geral';
import Parametro from '../../../core/domain/geral/Parametro';
import { InformativoService, ParametroService } from '../../../core/services/geral';
import NFSeService from '../../../core/services/fiscal/NFSeService';

export default {
	data:() => ({
		tabActive: null,
		valid: true,
		serviceParametro: new ParametroService(),
		serviceInformativo: new InformativoService(),
		serviceNFSe: new NFSeService(),
		parametro: new Parametro(),
		informativo: new Informativo(),
		primeiraCarga: true,
		sessionApp: {},
		certificadoArquivo: null,
		enviandoCertificado: false,
	}),
	methods: {
		Atualizar(){
		this.primeiraCarga = true;
		this.sessionApp = JSON.parse(localStorage.sessionApp);

		this.serviceParametro.ListarTudo().then(
			res=>{
				this.parametro = new Parametro(res.data.items[0]);
			},
			err=>{
				this.$swal('Aviso', err.message, 'error');
			}
		).finally(() =>{
			this.primeiraCarga = false;
		})
		this.serviceInformativo.ListarTudo().then(
			res => {
				this.informativo = new Informativo(res.data.items[0]);
				if(!(!!this.informativo.emails))
					this.informativo.emails = "";
			},
			err=>{
				this.$swal('Aviso', err.message, 'error');
			}
		)
		},
		EnviarAgora(){
			this.primeiraCarga = true;
			this.serviceInformativo.EnviarAgora().then(
				res => {
					this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
				},
				err=>{
					if (err.response.status == 400) {
						this.$swal('Aviso', err.response.data, 'warning')    
					}
					else {
						this.$swal('Aviso', err.response.data, 'error')
					}
				}
			).finally(() => {
				this.primeiraCarga = false;
			})
		},
		Salvar(){
      this.primeiraCarga = true;
			this.serviceParametro.Salvar(this.parametro).then(
				res => {
					this.serviceInformativo.Salvar(this.informativo).then(
					res => {
						this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
						this.Atualizar();
					},
					err =>  {
						if (err.response.status == 400) {
						this.$swal('Aviso', err.response.data.title, 'warning')    
						}
						else {
						this.$swal('Aviso', err.response.data, 'error')
						}
					}
					)
				}, 
				err =>  {
					if (err.response.status == 400) {
					this.$swal('Aviso', err.response.data.title, 'warning')
					}
					else {
					this.$swal('Aviso', err.response.data, 'error')
					}
				}
			).finally(() => {
        this.primeiraCarga = false;
      })
		},
		EnviarCertificadoDigital(){
			if (!this.certificadoArquivo){
				this.$swal('Aviso', 'Selecione o arquivo do certificado.', 'warning');
				return;
			}
			if (!!!this.parametro.certificadoSenha){
				this.$swal('Aviso', 'Informe a senha do certificado.', 'warning');
				return;
			}

			this.enviandoCertificado = true;
      this.primeiraCarga = true;
			this.serviceParametro.EnviarCertificadoDigital(this.certificadoArquivo, this.parametro.certificadoSenha).then(
				res => {
					const nomeArquivo = this.certificadoArquivo ? this.certificadoArquivo.name : '';
					this.$swal('Aviso', 'Operacao realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
					if (nomeArquivo){
						this.parametro.certificadoNome = nomeArquivo;
					}
					this.certificadoArquivo = null;
				},
				err => {
				if (err.response && err.response.status == 400) {
					this.$swal('Aviso', err.response.data, 'warning');
				}
				else if (err.response) {
					this.$swal('Aviso', err.response.data, 'error');
				}
				else {
					this.$swal('Aviso', err.message, 'error');
				}
				}
			).finally(() => {
				this.enviandoCertificado = false;
        this.primeiraCarga = false;
			})
		},
		LimparCertificadoNome(){
			this.parametro.certificadoNome = '';
			this.certificadoArquivo = null;
		}
	},
	mounted() {
		this.Atualizar()
	}
}
</script>

<style>
	.sticky{
		position: -webkit-sticky;
		position: sticky;
		top: 70px;
		z-index: 5;
	}
</style>
